import React from 'react';
import { Row, Col } from 'antd';
import { SwapLeftOutlined } from '@ant-design/icons';

import BorderlessButton from '../../common/buttons/BorderlessButton';

import Logo from '../../common/Logo';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

export default ({
  title,
  integrationKey,
  onChanged,
  syncSettings = {},
  showLogos = true,
  integrationLogo,
  pushHelp,
  pullHelp,
}) => {
  const pushKey = `${integrationKey}IntegrationPush`;
  const pullKey = `${integrationKey}IntegrationPull`;
  const {
    [pushKey]:pushSetting,
    [pullKey]:pullSetting,
  } = syncSettings;
  return (
    <Row style={{ width: '100%', margin:0,  }} justify='center' align='middle' gutter={30}>
      <Row style={{ width: '100%'}} gutter={10}>
        <Col>
          <OnTraccrCheckbox
            value={pullSetting}
            onChange={() => onChanged({
              [pullKey]:!pullSetting,
              [pushKey]:pushSetting
            })}
            label={`Auto-Sync from ${title} to Ontraccr`}
            hoverNode={pullHelp}
            helpPlacement="rightTop"
          />
        </Col>
      </Row>
      <Row style={{ width: '100%', marginTop: 15 }} gutter={10}>
        <Col>
          <OnTraccrCheckbox
            value={pushSetting}
            onChange={() => onChanged({
              [pullKey]:pullSetting,
              [pushKey]:!pushSetting
            })}
            label={`Auto-Sync from Ontraccr to ${title}`}
            hoverNode={pushHelp}
            helpPlacement="rightTop"
          />
        </Col>
      </Row>
      {showLogos && <Row style={{ width: '100%', marginTop: 100 }} justify='center' align='middle' gutter={20}>
        <Col>
          <Logo height={95}/>
        </Col>
        <Col>
          <Row>
            <BorderlessButton
              iconNode={
                <SwapLeftOutlined
                  style={{
                    margin:0,
                    fontSize: 40,
                    color: pullSetting ? 'forestgreen' : 'lightgray',
                  }}
                />
              }
              onClick={() => onChanged({
                [pullKey]:!pullSetting,
                [pushKey]:pushSetting
              })}
            />
          </Row>
          <Row>
            <BorderlessButton
              iconNode={
                <SwapLeftOutlined
                  style={{
                    margin:0,
                    fontSize: 40,
                    color: pushSetting ? 'forestgreen' : 'lightgray',
                  }}
                  rotate={180}/>
              }
              onClick={() => onChanged({
                [pullKey]:pullSetting,
                [pushKey]:!pushSetting
              })}
            />
          </Row>
        </Col>
        <Col>
          {integrationLogo}
        </Col>
      </Row>}
    </Row>
  )
};
